import { extend, $$, addEvent, $, hasParentsClass } from './HelperFunctions'

export class MainNavigation {
  constructor (settings, selectors, classes) {
    this.settings = extend({}, settings)

    this.selectors = extend({
      block: '.main-navigation',
      level1: '.main-navigation__level-1',
      level2: '.main-navigation__level-2',
      level3: '.main-navigation__level-3',
      linksWithSubtree: '.main-navigation--has-subtree',
      active: '.main-navigation--active',
      back: '.main-navigation__back',
      page: '.page'
    }, selectors)

    this.classes = extend({
      block: 'main-navigation',
      active: 'main-navigation--active',
      buttonClose: 'main-navigation__close',
      showLevel1: 'main-navigation--level-1',
      showLevel2: 'main-navigation--level-2',
      showLevel3: 'main-navigation--level-3'
    }, classes)
  }

  init () {
    this.addEvents()
  }

  addEvents () {
    const linksWithSubtree = $$(this.selectors.linksWithSubtree)
    linksWithSubtree.forEach((linkWithSubtree) => {
      addEvent(linkWithSubtree, 'click', (event) => {
        event.preventDefault()

        $$(this.selectors.active).forEach((activeLink) => {
          if (activeLink !== linkWithSubtree && !this.ifParentsLink(linkWithSubtree, activeLink)) {
            activeLink.classList.remove(this.classes.active)
          }
        })

        linkWithSubtree.classList.toggle(this.classes.active)

        this.setLevel(linkWithSubtree)

        if (!linkWithSubtree.classList.contains(this.classes.active)) {
          linkWithSubtree.blur()
        }
      })
    })

    addEvent($('body'), 'click', (event) => {
      if ((!hasParentsClass(event.target, this.classes.block) || hasParentsClass(event.target, this.classes.buttonClose)) && window.innerWidth > 767) {
        $$(this.selectors.active).forEach((activeLink) => {
          activeLink.classList.remove(this.classes.active)
        })

        $$(this.selectors.block).forEach((block) => {
          block.classList.remove(this.classes.showLevel1, this.classes.showLevel2, this.classes.showLevel3)
        })
      }
    })

    $$(this.selectors.back).forEach((backButton) => {
      addEvent(backButton, 'click', (event) => {
        const parentLevel = backButton.closest(this.selectors.level1 + ',' + this.selectors.level2 + ',' + this.selectors.level3)
        const activeLink = $(this.selectors.active, parentLevel.parentElement)

        if (activeLink) {
          activeLink.click()
        }
      })
    })
  }

  ifParentsLink (element, checkElement) {
    if (element.tagName === 'LI') {
      for (const child of element.children) {
        if (child === checkElement) {
          return true
        }
      }
    }

    return element.parentElement && this.ifParentsLink(element.parentElement, checkElement)
  }

  setLevel (link) {
    let level = this.getLinkLevel(link)
    const block = link.closest(this.selectors.block)

    if (!link.classList.contains(this.classes.active)) {
      level--
    }

    if (level === 2) {
      block.classList.remove(this.classes.showLevel1, this.classes.showLevel3)
      block.classList.add(this.classes.showLevel2)
    } else if (level === 3) {
      block.classList.remove(this.classes.showLevel1, this.classes.showLevel2)
      block.classList.add(this.classes.showLevel3)
    } else {
      block.classList.remove(this.classes.showLevel2, this.classes.showLevel3)
      block.classList.add(this.classes.showLevel1)
    }
  }

  getLinkLevel (link) {
    if (link.closest(this.selectors.level2)) {
      return 3
    } else if (link.closest(this.selectors.level1)) {
      return 2
    }

    return 1
  }
}

export default MainNavigation
